__turbopack_context__.v({
  "container": "v4VKVq_container",
  "header": "v4VKVq_header",
  "tag": "v4VKVq_tag",
  "tagsList": "v4VKVq_tagsList",
});
